<script type="text/ecmascript-6">
    import Layout from '../layouts/MainLayout.vue'
    import Chart from 'chart.js';
    import TopHeader from "../components/TopHeader";
    import DateRange from "../components/DateRange";
    import {mapGetters} from "vuex";

    export default {
        components: {DateRange, TopHeader, Layout },

        /**
         * The component's data.
         */
        data: () => ({
            engagementChart: null,
        }),

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                dateTime: 'getDateTime',
                ownPageData: 'getOwnPageData',
                isPreview: 'getIsPreview',
                isPrint: 'getIsPrint',
                competitors: 'getCompetitors',
                competitor_avg: 'getCompetitorAvg',
            })
        },

        watch: {
            isLoading(newData) {
                if (!newData) {
                    this.pagesByEngagementChart();
                }
            }
        },

        mounted() {
            this.pagesByEngagementChart();
        },

        methods: {
            pagesByEngagementChart() {

                if (this.engagementChart) {
                    this.engagementChart.destroy();
                }

                var ctx = document.getElementById('myChart');

                var color;

                color = this.getRandomColor();

                this.engagementChart = new Chart(ctx, {
                    // The type of chart we want to create
                    type: 'bar',

                    // The data for our dataset
                    data: {
                        labels: this.competitors.map(item => item.name),
                        datasets: [
                            {
                                label: "Pages By Engagement",
                                backgroundColor: color,
                                borderColor: color,
                                data: this.competitors.map(item => item.engagement),
                            }
                        ]
                    },

                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    // Shorthand the millions
                                    callback: (value) => {
                                        return this.abbrNum(value, 2);
                                    }
                                }
                            }],
                            xAxes: [{
                                ticks: {
                                    // Shorthand the millions
                                    callback: (value) => {
                                        return value;
                                    }
                                }
                            }]
                        },
                        responsive: false, // Instruct chart js to respond nicely.
                        title: {
                            display: true,
                            text: 'Page By Engagement'
                        },
                        legend: {
                            display: false
                        }
                    }
                });
            },

        },

        beforeDestroy() {
            if (this.engagementChart) {
                this.engagementChart.destroy();
            }
        },
    }
</script>

<template>
    <layout>
        <div :class="{'container-fluid' : !isPreview }" v-show="!isLoading">
            <date-range></date-range>

            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow">
                <div class="card-body">

                    <TopHeader name="Competitor Benchmark"></TopHeader>

                    <div class="row mt-5 mb-2">
                        <div class="col-md-12 text-black">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">FANS</th>
                                    <th scope="col">EVOLUTION</th>
                                    <th scope="col">ENGAGEMENT</th>
                                    <th scope="col">POSTS</th>
                                    <th scope="col">ENGAGEMENT RATE/POST</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="competitor in competitors" v-bind:key="competitor.id">
                                    <th scope="row">
                                        <img :src="competitor.picture" class="rounded-circle" width="50" alt=""/>
                                        <div class="pt-2 pl-3 pb-2 d-inline-block">
                                            <h6> {{ competitor.name }}</h6>
                                        </div>
                                    </th>
                                    <td>{{ competitor.fans }}</td>
                                    <td>{{ competitor.evolution }}</td>
                                    <td>{{ competitor.engagement }}</td>
                                    <td>{{ competitor.posts }}</td>
                                    <td>{{ competitor.engagement_rate_par_post }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row mt-3 border-top border-bottom">
                        <div class="col-8 pr-5 border-right">
                            <canvas style="width: 100%" height="370px" id="myChart"></canvas>
                        </div>

                        <div class="col-4 mt-auto mb-auto">
                            <h4 class="text-black text-center">AVERAGE BENCHMARKS</h4>
                            <div class="d-flex flex-row mt-5">
                                <div style="width: 40%"></div>
                                <div>
                                    <div class="d-flex flex-row">
                                        <div>
                                            <i class="far fa-2x fa-heart text-black"></i>
                                        </div>
                                        <div class="pl-3">
                                            <h4 class="text-black font-weight-bolder">{{ abbrNum(competitor_avg.fans, 2) }}</h4>
                                            <h5 class="text-black">FANS</h5>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-row mt-4">
                                        <div>
                                            <i class="fa fa-2x fa-chart-bar text-black"></i>
                                        </div>
                                        <div class="pl-3">
                                            <h4 class="text-black font-weight-bolder">{{ numberFormat(competitor_avg.engagement) }}</h4>
                                            <h5 class="text-black">ENGAGEMENT</h5>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-row mt-4">
                                        <div>
                                            <div class="rotate-n-40">
                                                <i class="fas fa-2x fa-hashtag text-black"></i>
                                            </div>
                                        </div>
                                        <div class="pl-3">
                                            <h4 class="text-black font-weight-bolder">{{ competitor_avg.posts }}</h4>
                                            <h6 class="text-black">POSTS</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-12 mb-5">
                            <h4 class="text-black">Top 3 Creatives of each pages</h4>
                        </div>
                    </div>

                    <div class="row mb-4">
                        <div class="col-6" v-for="competitor in competitors" v-bind:key="competitor.id">
                            <div class="d-flex flex-row mb-2">
                                <div>
                                    <img :src="competitor.picture" class="rounded-circle" width="50"  alt=""/>
                                </div>
                                <div class="pl-3 mt-auto mb-auto">
                                    <h4 class="text-black text-center">{{ competitor.name }}</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4" v-for="topPost in competitor.topPosts" v-bind:key="topPost.link">
                                    <img :data-src="topPost.picture" class="img-thumbnail" alt="200x200" :src="topPost.picture" data-holder-rendered="true">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </layout>
</template>
